import $ from 'jquery';
import Vue from 'vue';
import { convertDateToDdMmYyyy } from '@/function/function.js';

import EnteteBonEtFacture from '@/views/en-tete-bon-facture';


import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

export default {
    name: 'resultat-nfs',
    components: {
        VueHtml2pdf, EnteteBonEtFacture
    },
    props: [],
    data() {
        return {
            date_resultat: '', //  Date d'enregistrement du résultat
            user_role: '',
            result_loading: true
        }
    },
    computed: {
        prescripteur() {
            return this.$store.getters["prescripteur"];
        },
        resultat() {
            return this.$store.getters["resultat"];
        },
        totalNumerationBlanche() {
            let total = Number.parseFloat(parseFloat(this.resultat.PN) + parseFloat(this.resultat.PE) + parseFloat(this.resultat.MONO) + parseFloat(this.resultat.LYM) + parseFloat(this.resultat.PB)).toFixed(2);
            if (total == "NaN" || Number.isNaN(total)) return null
            else
                return Number.parseFloat(parseFloat(this.resultat.PN) + parseFloat(this.resultat.PE) + parseFloat(this.resultat.MONO) + parseFloat(this.resultat.LYM) + parseFloat(this.resultat.PB)).toFixed(2);
        },
        percentLympho() {
            if (this.totalNumerationBlanche == 0 || this.totalNumerationBlanche == null) {
                return null;
            } else {
                return Number.parseFloat(100 * this.resultat.LYM / this.totalNumerationBlanche).toFixed(2)
            }

        },
        monoPercent() {
            if (this.totalNumerationBlanche == 0 || this.totalNumerationBlanche == null) {
                return null;
            } else {
                return Number.parseFloat(100 * this.resultat.MONO / this.totalNumerationBlanche).toFixed(2)
            }
        },
        pbPercent() {
            if (this.totalNumerationBlanche == 0 || this.totalNumerationBlanche == null) {
                return null;
            } else {
                return Number.parseFloat(100 * this.resultat.PB / this.totalNumerationBlanche).toFixed(2)
            }
        },
        pePercent() {
            if (this.totalNumerationBlanche == 0 || this.totalNumerationBlanche == null) {
                return null;
            } else {
                return Number.parseFloat(100 * this.resultat.PE / this.totalNumerationBlanche).toFixed(2)
            }
        },
        pnPercent() {
            if (this.totalNumerationBlanche == 0 || this.totalNumerationBlanche == null) {
                return null;
            } else {
                return Number.parseFloat(100 * this.resultat.PN / this.totalNumerationBlanche).toFixed(2)
            }
        },


        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        }

    },
    mounted() {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date()); // Temporaire. NB : A remplacer par la date du resultat
        this.$store.dispatch("getDemandeResult", this.$route.params.resultat_id).then(
            () => {
                this.result_loading = false
                if (this.resultat.user_id !== null) {
                    this.$store.dispatch("getPrescripteur", this.resultat.user_id)
                } else {
                    this.$store.commit("SET_PRESCRIPTEUR", null)
                }


            }
        )

        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;

        }
    },
    methods: {
        printResultatNFS() {
            this.$refs.nfs_html2Pdf.generatePdf()

        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_caisse = 'Le biologiste';
                let lome_le = this.ville_le + this.date_resultat;

                // LOME LE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1.2))

                // LA CAISSE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(la_caisse, (7), (pdf.internal.pageSize.getHeight() - 1.2))

                // FOOTER
                pdf.setTextColor(150)
                pdf.setFontSize(8)
                pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
            }).save()
        },

        onProgress(ev) {
            console.log(ev)
        },

        hasStartedGeneration() {

        },

        hasGenerated(ev) {
            console.log(ev)
        }
    }
}